"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_INPUT = void 0;
// Actions
var SET_INPUT = 'RI_SET_INPUT';
exports.SET_INPUT = SET_INPUT;


//////////////////
// WEBPACK FOOTER
// ./~/redux-inputs/lib/actions/actionTypes.js
// module id = 343
// module chunks = 0